export const viewPdfDialogStyles = (theme) => ({
  alertContainer: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  alert: {
    width: '100%',
    maxWidth: '900px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    fontSize: '1rem',
    borderRadius: theme.shape.borderRadius,
    '& .MuiAlert-icon': {
      fontSize: '1.6rem',
      marginRight: theme.spacing(1.5),
    },
    '& .MuiAlert-message': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
    },
  },
  pdfWrapper: {
    display: 'flex',
    justifyContent: 'center',
  },
  pdfButtonsWrapper: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px 0 40px 0',
  },
  pdfButton: {
    margin: '0 10px',
  },
})
